import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaEnvelope, 
  FaPhone, 
  FaMapMarkerAlt, 
  FaInstagram, 
  FaWhatsapp,
  FaArrowUp 
} from 'react-icons/fa';
import './Footer.scss';

const Footer: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          <motion.div 
            className="footer__brand"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="footer__logo">
              <img src="/logo-white.png" alt="beheard" className="footer-logo-img" />
            </div>
            <p className="footer__description">
              Единая коммуникационная платформа для полного контроля над процессами. 
              Оптимизируйте рутиные задачи, экономьте время и масштабируйте бизнес.
            </p>
            <div className="footer__contact">
              <div className="contact-item">
                {/* @ts-ignore */}
                <FaEnvelope className="contact-icon" />
                <a href="mailto:beheardkz@gmail.com">beheardkz@gmail.com</a>
              </div>
              <div className="contact-item">
                {/* @ts-ignore */}
                <FaPhone className="contact-icon" />
                <a href="tel:+77774059845">+7 777 405 9845</a>
              </div>
              <div className="contact-item">
                {/* @ts-ignore */}
                <FaMapMarkerAlt className="contact-icon" />
                <span>Казахстан, Астана</span>
              </div>
              <div className="contact-item">
                {/* @ts-ignore */}
                <FaInstagram className="contact-icon" />
                <a href="https://instagram.com/beheard.kz" target="_blank" rel="noopener noreferrer">@beheard.kz</a>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="footer__links"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="footer__column">
              <h4 className="footer__column-title">Платформа</h4>
              <ul className="footer__list">
                <li>
                  <button 
                    className="footer__link"
                    onClick={() => scrollToSection('features')}
                  >
                    Возможности
                  </button>
                </li>
                <li>
                  <button 
                    className="footer__link"
                    onClick={() => scrollToSection('advantages')}
                  >
                    Преимущества
                  </button>
                </li>
                <li>
                  <button 
                    className="footer__link"
                    onClick={() => scrollToSection('contact')}
                  >
                    Связаться с нами
                  </button>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>

        <motion.div 
          className="footer__bottom"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          {/* Inspirational quote */}
          <div className="footer__quote">
            <span className="footer__quote-mark">&ldquo;</span>
            <p className="footer__quote-text">
              Хаос в заявках стоит бизнесу дороже, чем любой инструмент для их контроля.
            </p>
            <span className="footer__quote-author">— Команда beheard</span>
          </div>

          <div className="footer__bottom-content">
            <div className="footer__copyright">
              <p>&copy; {new Date().getFullYear()} beheard. Все права защищены.</p>
            </div>

            <div className="footer__social">
              <a href="https://wa.me/77774059845" className="social-link" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
                {/* @ts-ignore */}
                <FaWhatsapp />
              </a>
              <a href="https://instagram.com/beheard.kz" className="social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                {/* @ts-ignore */}
                <FaInstagram />
              </a>
            </div>
          </div>

          <motion.button 
            className="footer__scroll-top"
            onClick={scrollToTop}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            aria-label="Наверх"
          >
            {/* @ts-ignore */}
            <FaArrowUp />
          </motion.button>
        </motion.div>
      </div>

      {/* Structured Data for Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "beheard",
          "url": "https://beheardkz.com",
          "logo": "https://beheardkz.com/logo.png",
          "description": "Система для подачи, обработки и отслеживания заявок",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+7-777-405-98-45",
            "contactType": "customer service",
            "email": "beheardkz@gmail.com"
          },
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "KZ",
            "addressLocality": "Астана"
          },
          "sameAs": [
            "https://instagram.com/beheard.kz",
            "https://wa.me/77774059845"
          ]
        })}
      </script>
    </footer>
  );
};

export default Footer;
